'use client'

import { ContentBlock as ContentBlockType } from '@onclicks/payload-types'
import { ContentWithLinkBar } from '../components/Content/ContentWithLinkBar'
import { DefaultContent } from '../components/Content/DefaultContent'

const content = {
  default: DefaultContent,
  linkbar: ContentWithLinkBar,
}

const ContentBlock: React.FC<
  {
    className: string
    disableInnerContainer?: boolean
  } & ContentBlockType
> = (props) => {
  const { variant } = props || {}

  if (!variant) return null

  const ContentToRender = content[variant]

  if (!ContentToRender) return null

  return <ContentToRender {...props} />
}

export default ContentBlock
